import React from "react"
import { Control, FormState } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormSectionLeftIndent, IFormBase, TClearError, TextButton, TSetError } from "swiipe.portal.shared"

import { useReduxDispatch } from "../../store/useReduxDispatch"
import DigitealPersonFields from "./DigitealPersonFields"
import "./DigitealPersons.scss"

interface IDigitealPersonsProps<TForm extends IFormBase> {
    control: Control<TForm>
    setError: TSetError<any>
    clearError: TClearError<any>
    formState: FormState<TForm>
    showErrors: boolean
    fieldSelectorPrefix: string
    personCountState: [number, (personCount: number) => void]
}

const DigitealPersons = <TForm extends IFormBase>({
    control,
    setError,
    clearError,
    formState,
    showErrors,
    fieldSelectorPrefix,
    personCountState,
}: IDigitealPersonsProps<TForm>) => {
    const { t } = useTranslation()
    const dispatch = useReduxDispatch()

    const getFieldSelector = (fieldName: string) => fieldSelectorPrefix + fieldName
    const [personCount, setPersonCount] = personCountState

    const DeleteBtn = () => {
        return (
            <span
                className="person-delete-btn"
                onClick={() => {
                    setPersonCount(personCount - 1)
                }}
            >
                {" "}
                ×
            </span>
        )
    }

    const AddButton = () => {
        return (
            <div className="person-add-btn">
                <hr />
                <TextButton
                    text={`+ ${t("digitealKyc.ubos.add")}`}
                    onClick={async () => setPersonCount(personCount + 1)}
                    textDecoration="underline"
                    fontSize="big"
                    display="inline-block"
                    fontWeight="600"
                    color="purple"
                />
            </div>
        )
    }

    return (
        <div className="digiteal-persons">
            {Array.from({ length: personCount }).map((v, i) => {
                return (
                    <div key={i}>
                        <div>
                            {i > 0 && <hr />}
                            <p className="digiteal-persons__person-header text-center mt-4 mb-3">
                                {t("digitealKyc.ubos.sectionTitle")}
                                {personCount > 1 && <DeleteBtn />}
                            </p>
                        </div>
                        <div className="digiteal-persons__person-fields">
                            <FormSectionLeftIndent>
                                <DigitealPersonFields
                                    control={control}
                                    register={control.register}
                                    clearError={clearError}
                                    setError={setError}
                                    showErrors={showErrors}
                                    formState={formState}
                                    fieldSelectorPrefix={`${fieldSelectorPrefix}[${i}].`}
                                    saveJustTriggered={false}
                                />
                            </FormSectionLeftIndent>
                        </div>
                    </div>
                )
            })}
            <AddButton />
        </div>
    )
}

export default DigitealPersons
